import React from "react";
import {useNavigate} from "react-router-dom";

import Page from "@/components/Page";
import EmptyData from "@/components/EmptyData";
import MainActions from "@/components/MainActions";

import HomeIcon from "@mui/icons-material/Home";

import "./index.scss";

function NotFoundPage() {
	const navigate = useNavigate();

	return (
		<Page>
			<div className="not-found-page">
				<EmptyData
					action={
						<MainActions
							actions={[
								{
									icon: <HomeIcon />,
									label: "Torna alla home",
									onClick: () => navigate("/"),
								},
							]}
						/>
					}
				>
					<div className="not-found-page__title">Pagina non trovata</div>
					<div>La pagina che cerchi non esiste o è stata spostata.</div>
				</EmptyData>
			</div>
		</Page>
	);
}

export default NotFoundPage;
